import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { stringSorter } from "../../utils/functions.js";
import DataTable from "../../components/CustomDatatable/index.js";
import {
  Card,
  Space,
  Typography,
  Breadcrumb,
  Row,
  Col,
  Modal,
  Button,
} from "antd";
import { HomeOutlined } from "@ant-design/icons";
import {
  getFeedback,
  updateFeedbackStatus,
} from "../../store/actions/feedback.js";
import { Spinner } from "reactstrap";
import { enhanceColumnsWithFilters } from "../../components/ColumnFilters/index.js";
import CustomToggleSwitch from "../../components/CustomToggleSwitch.js";
import { Image } from "antd";

// import { DataGrid, GridToolbar } from "@mui/x-data-grid";
const { Title } = Typography;

const Feedback = () => {
  document.title = "Global Feedback List";
  const [isLoading, setIsLoading] = useState(true);
  const dispatch = useDispatch();
  const feedback = useSelector((state) => state.feedback.list || []);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalImages, setModalImages] = useState([]);

  useEffect(() => {
    const fetchFeedback = async () => {
      try {
        await dispatch(getFeedback());
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
      }
    };

    fetchFeedback();
  }, [dispatch]);

  const handleChangeStatus = async (id, status) => {
    const formData = new FormData();

    formData.append("id", id);
    formData.append("status", status);
    console.log("id", id, status);
    await dispatch(updateFeedbackStatus(id, status));
    await dispatch(getFeedback());
  };

  const handleImageClick = (images) => {
    setModalImages(images);
    setIsModalVisible(true);
  };

  const handleModalClose = () => {
    setIsModalVisible(false);
  };

  const renderCell = (text) => (text ? text : "");
  const userRenderCell = (text) => (text ? text : "User");
  let columns = [
    {
      title: "Type",
      dataIndex: "typeName",
      key: "typeName",
      sorter: stringSorter("typeName"),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Comment",
      dataIndex: "comment",
      key: "comment",
      sorter: stringSorter("comment"),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Image",
      dataIndex: "screenshot",
      key: "screenshot",
      sorter: stringSorter("screenshot"),
      sortDirections: ["ascend", "descend"],
      render: (_, record) => {
        const images = record?.screenshotsLive;

        console.log("images:", images);

        if (!images || images.length === 0) {
          return "No Image";
        }

        return (
          <div style={{ display: "flex", gap: 8 }}>
            {images.map((item, idx) => (
              <Image
                key={idx}
                width={100}
                height={80}
                src={item}
                alt="Screenshot"
                crossOrigin="anonymous"
              // preview={true}
              // fallback="https://via.placeholder.com/100"
              />
            ))}
          </div>
        );
      },
    },
    // {
    //   title: "Status",
    //   dataIndex: "status",
    //   key: "status",
    //   render: (status, record) => (
    //     <CustomToggleSwitch
    //       record={record}
    //       onChangeStatus={handleChangeStatus(record.id, record.status)}
    //     />
    //   ),
    //   sorter: (a, b) => a.status.localeCompare(b.status),
    // }
  ];
  columns = enhanceColumnsWithFilters(columns);

  return (
    <div className="page-content">
      <Breadcrumb style={{ marginBottom: "16px" }}>
        <Breadcrumb.Item href="/">
          <HomeOutlined />
        </Breadcrumb.Item>
       <Breadcrumb.Item href="/dashboard">Dashboard</Breadcrumb.Item>
        <Breadcrumb.Item>Feedback</Breadcrumb.Item>
      </Breadcrumb>

      <Card>
        <Space direction="vertical" size="middle" style={{ width: "100%" }}>
          <Row justify="space-between" align="middle">
            <Col>
              <Title level={2} style={{ margin: 0 }}>
                Manage Feedback
              </Title>
            </Col>
            <Col></Col>
          </Row>
          {isLoading ? (
            <div className="d-flex justify-content-center">
              <Spinner animation="border" variant="primary" />
            </div>
          ) : (
            <DataTable
              dataSource={feedback.map((item) => ({
                ...item,
                key: item.id,
                status: item.status ? 1 : 0,
              }))}
              columns={columns}
              filterBy={[
                {
                  field: "type",
                  fieldType: "SELECT",
                  options: [{ id: 1, name: "Error" }, { id: 2, name: "Review" }, { id: 3, name: "Suggestion" }],
                  filter: "id",
                  label: "Type",
                },
              ]}
            />
          )}
        </Space>
      </Card>

      {/* Modal to display multiple images */}
      <Modal
        title="Feedback Images"
        visible={isModalVisible}
        onCancel={handleModalClose}
        footer={[
          <Button key="close" onClick={handleModalClose}>
            Close
          </Button>,
        ]}
        width={800}
      >
        <div className="image-gallery">
          {modalImages.map((image, index) => (
            <img
              key={index}
              src={image}
              alt={`Screenshot ${index + 1}`}
              style={{
                width: "100%",
                height: "auto",
                marginBottom: "10px",
                objectFit: "cover",
              }}
            />
          ))}
        </div>
      </Modal>
    </div>
  );
};

export default Feedback;
